import { Stack, Typography, styled } from "@mui/material";

export const Container = styled(Stack)(({ theme }) => ({
  minHeight: "100vh",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#F7F8FC",
  padding: theme.spacing(4),
}));

export const LogoContainer = styled("div")({
  display: "flex",
  justifyContent: "center",
});

export const StyledTitle = styled(Typography)({
  fontWeight: "bold",
  color: "#1A1A1A",
  textAlign: "center",
});

export const SubTitle = styled(Typography)({
  color: "#666",
  fontSize: "14px",
  textAlign: "center",
});

export const CodeInputContainer = styled("div")({
  display: "flex",
  gap: "10px",
  justifyContent: "center",
});

export const CodeInput = styled("input")({
  width: "50px",
  height: "50px",
  borderRadius: "8px",
  border: "1px solid #D9D9D9",
  textAlign: "center",
  fontSize: "24px",
  outline: "none",
  fontWeight: "bold",
  backgroundColor: "#fff",
  "&:focus": {
    borderColor: "#0F84FF",
    boxShadow: "0 0 0 2px rgba(15, 132, 255, 0.2)",
  },
});

export const ResendLink = styled("a")({
  color: "#0F84FF",
  fontSize: "14px",
  textDecoration: "none",
  "&:hover": {
    textDecoration: "underline",
  },
});

export const FooterText = styled(Typography)({
  marginTop: "32px",
  fontSize: "12px",
  color: "#999",
  textAlign: "center",
});
